import { ChangeEvent, useCallback, useState } from 'react'
import { BreadType } from 'types/bread'

const useSelectBreads = (breads: BreadType[]) => {
  const [selectedBreads, setSelectedBreads] = useState<BreadType[]>([])

  const selectBread = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const breadId = event.target.id
      setSelectedBreads((prevState) => {
        if (prevState.some((_bread) => _bread.bread_ref && _bread.bread_ref.id === breadId)) {
          return prevState.filter((_bread) => _bread.bread_ref && _bread.bread_ref.id !== breadId)
        } else {
          const bread = breads.find((bread) => bread.bread_ref && bread.bread_ref.id === breadId)
          if (!bread) return prevState
          return [...prevState, bread]
        }
      })
    },
    [setSelectedBreads, breads]
  )

  const selectAllBreads = useCallback(
    () => setSelectedBreads((prevState) => [...prevState, ...breads]),
    [setSelectedBreads, breads]
  )

  const unselectAllBreads = useCallback(
    () =>
      setSelectedBreads((prevState) =>
        // prevStateから、絞り込み後のbreadsを除外したものを返す
        [...prevState.filter((prev) => !breads.some((bread) => bread.bread_ref?.id === prev.bread_ref?.id))]
      ),
    [setSelectedBreads, breads]
  )

  return {
    selectBread,
    selectedBreads,
    selectAllBreads,
    setSelectedBreads,
    unselectAllBreads,
  }
}

export default useSelectBreads
